export const AVENTRIA_LANDING_PAGE_FLAG_VALUES = {
  DIRECTORY: 'directory',
  INQUIRY: 'inquiry',
} as const;
